// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3Xnet","header":"PatientQuestionnaire_header__1eOVi","info":"PatientQuestionnaire_info__3rIrg"};